<xform-page [sidebar]="false" [bgColor]="'white-bg'">
  <section class="container-fluid public-form">

    <ng-container *ngIf="authenticationService.isLoggedIn() === false; else signout">
      <button class="btn btn-primary signin" (click)="authenticationService.login()"> Sign in with Okta </button>
    </ng-container>

    <ng-template #signout>
      <button class="btn btn-primary signin"  (click)="authenticationService.logout()">Sign out</button>
    </ng-template>
  </section>
</xform-page>

